/* ============= Custom Tab =============  */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.c-tab');
  if (!tab) return;
  var ancestorEle = tab.closest('.c-tab-panel');
  if (!ancestorEle) return;

  var activeEls = ancestorEle.getElementsByClassName('is-active');
  if (activeEls.length) activeEls[0].classList.remove('is-active');
  tab.classList.add('is-active');

  var showEls = ancestorEle.getElementsByClassName('is-show');
  if (showEls.length) showEls[0].classList.remove('is-show');

  var groupTabs = ancestorEle.getElementsByClassName('c-tab');
  var arrayTabs = Array.prototype.slice.call(groupTabs);
  var index = arrayTabs.indexOf(tab);
  var panels = ancestorEle.getElementsByClassName('c-panel');
  if (index >= 0 && panels[index]) {
    panels[index].classList.add('is-show');
    requestAnimationFrame(function () {
      updateCategoryListShowMore(panels[index]);
    });
  }
});

/* ============= Category List Show More =============  */
var categoryListMobileQuery = window.matchMedia('(max-width: 767px)');

function getCategoryListRowTops(list) {
  var items = list.querySelectorAll('.c-category-list__item');
  var tops = [];
  var seen = {};

  for (var i = 0; i < items.length; i++) {
    var top = items[i].offsetTop;
    if (!seen[top]) {
      seen[top] = true;
      tops.push(top);
    }
  }

  return tops;
}

function getCategoryListRowHeight(list, rowTops, rowIndex) {
  var items = list.querySelectorAll('.c-category-list__item');
  var rowTop = rowTops[rowIndex];

  if (rowTops[rowIndex + 1] !== undefined) {
    return rowTops[rowIndex + 1] - rowTop;
  }

  for (var i = 0; i < items.length; i++) {
    if (items[i].offsetTop === rowTop) {
      return items[i].offsetHeight;
    }
  }

  return 0;
}

function applyCategoryListShowMore(wrap) {
  var clip = wrap.querySelector('.c-category-list-clip');
  var list = wrap.querySelector('.c-category-list');
  var button = wrap.querySelector('.c-category-list__toggle');
  if (!clip || !list || !button) return;

  var panel = wrap.closest('.c-panel');
  if (panel && !panel.classList.contains('is-show')) return;

  var isMobile = categoryListMobileQuery.matches;
  var minRowsForButton = isMobile ? 4 : 3;
  var maxVisibleRows = isMobile ? 4 : 3;
  var lastVisibleRowIndex = maxVisibleRows - 1;
  var isExpanded = wrap.classList.contains('is-expanded');
  var rowTops = getCategoryListRowTops(list);
  var totalRows = rowTops.length;
  var label = button.querySelector('.c-category-list__toggle-text');
  var icon = button.querySelector('.c-category-list__toggle-icon');

  if (totalRows < minRowsForButton) {
    button.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    wrap.classList.remove('is-expanded', 'is-collapsed');
    clip.style.maxHeight = '';
    return;
  }

  button.hidden = false;

  if (isExpanded) {
    wrap.classList.remove('is-collapsed');
    clip.style.maxHeight = '';
    if (label) label.textContent = '閉じる';
    if (icon) icon.textContent = '－';
    button.setAttribute('aria-expanded', 'true');
    return;
  }

  var rowHeight = getCategoryListRowHeight(list, rowTops, lastVisibleRowIndex);
  var partialFactor = 0.55;
  var maxHeight = rowTops[lastVisibleRowIndex] + rowHeight * partialFactor;

  wrap.classList.add('is-collapsed');
  clip.style.maxHeight = maxHeight + 'px';
  if (label) label.textContent = 'もっと見る';
  if (icon) icon.textContent = '＋';
  button.setAttribute('aria-expanded', 'false');
}

function updateCategoryListShowMore(root) {
  var scope = root || document;
  var wraps = scope.querySelectorAll('.c-category-list-wrap[data-show-more]');

  for (var i = 0; i < wraps.length; i++) {
    applyCategoryListShowMore(wraps[i]);
  }
}

function resetCategoryListExpanded() {
  var wraps = document.querySelectorAll('.c-category-list-wrap.is-expanded');
  for (var i = 0; i < wraps.length; i++) {
    wraps[i].classList.remove('is-expanded');
  }
}

function initCategoryListShowMore() {
  if (!document.querySelector('.c-category-list-wrap[data-show-more]')) return;

  updateCategoryListShowMore();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      resetCategoryListExpanded();
      updateCategoryListShowMore();
    }, 150);
  });

  if (categoryListMobileQuery.addEventListener) {
    categoryListMobileQuery.addEventListener('change', function () {
      resetCategoryListExpanded();
      updateCategoryListShowMore();
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.c-category-list__toggle');
    if (!button) return;

    var wrap = button.closest('.c-category-list-wrap[data-show-more]');
    if (!wrap) return;

    wrap.classList.toggle('is-expanded');
    applyCategoryListShowMore(wrap);
  });

  window.addEventListener('load', function () {
    updateCategoryListShowMore();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCategoryListShowMore);
} else {
  initCategoryListShowMore();
}
